<template>
  <div class="content-info content-info1">
    <div
      :gutter="15"
      style="height: 100%; padding: 0 10px"
      class="business-form"
      v-if="orderEntry"
    >
      <div class="clearfix">
        <el-col :sm="4">
          <div class="form-div clearfix">
            <label class="fl form-label">省</label>
            <el-input
              class="fl"
              v-model="form.provinceName"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="4">
          <div class="form-div clearfix">
            <label class="fl form-label">市</label>
            <el-input
              class="fl"
              v-model="form.city"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="4">
          <div class="form-div clearfix">
            <label class="fl form-label">区</label>
            <el-input
              class="fl"
              v-model="form.zone"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="4">
          <div class="form-div clearfix">
            <label class="fl form-label">街道</label>
            <el-input
              class="fl"
              v-model="form.street"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="4">
          <div class="form-div clearfix">
            <label class="fl form-label">社区</label>
            <el-input
              class="fl"
              v-model="form.shequ"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
      </div>
      <div class="clearfix">
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">客户姓名</label>
            <el-input
              class="fl"
              v-model="form.name"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">联系号码</label>
            <el-input
              class="fl"
              v-model="form.phone"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">客户类型</label>
            <el-input
              class="fl"
              v-model="form.type"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">地址</label>
            <el-input
              class="fl"
              v-model="form.address"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
      </div>
      <div class="clearfix">
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">负责人</label>
            <el-input
              class="fl"
              v-model="form.communityLeaders"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
        <el-col :sm="5">
          <div class="form-div clearfix">
            <label class="fl form-label">联系号码</label>
            <el-input
              class="fl"
              v-model="form.leadersPhone"
              placeholder="请输入"
            ></el-input>
          </div>
        </el-col>
      </div>
      <div class="clearfix" style="margin-top: 10px">
        <el-button
          size="mini"
          icon="el-icon-plus"
          style="margin-bottom: 10px"
          v-has="'/WebCustomer/info/addCustomer'"
          @click.stop="addCustomer(form.phone)"
          >新增客户</el-button
        >
        <el-button
          size="mini"
          icon="el-icon-plus"
          style="margin-bottom: 10px"
          v-has="'/jjyl/advicepgd/info/insertAdvicepgd'"
          @click.stop="addConsult(form.phone)"
          >咨询工单</el-button
        >
        <el-button
          size="mini"
          icon="el-icon-plus"
          style="margin-bottom: 10px"
          v-has="'/servicePgd/info/addServicepgd'"
          @click.stop="addOrder(form.id)"
          >实体工单</el-button
        >
        <el-button
          size="mini"
          icon="el-icon-plus"
          style="margin-bottom: 10px"
          v-has="'/WebCustomer/info/updateCustomer'"
          @click.stop="addService(form.id)"
          >查看客户</el-button
        >
      </div>
      <div class="clearfix">
        <!-- <el-col :sm="12"> -->
        <div class="sms_title">通话记录</div>
        <el-table
          class="form-table"
          :data="tableData1"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            fixed
            prop="date"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            fixed
            prop="agentId"
            label="操作员"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="remoteNum"
            label="对端号码"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="callType"
            show-overflow-tooltip
            label="通话类型"
          ></el-table-column>
          <el-table-column
            prop="timeLen"
            show-overflow-tooltip
            label="通话时长"
          ></el-table-column>
        </el-table>
        <Paginationmini
          :pageConfig="pageConfig1"
          @currentPage="currentChange1"
          @pageSize="pageSizeChange1"
        ></Paginationmini>
        <div class="sms_home"></div>
        <!-- </el-col> -->
        <!-- <el-col :sm="12"> -->
        <div class="sms_title">咨询工单</div>
        <el-table
          class="form-table"
          :data="tableDatas"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            fixed
            prop="date"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="ordernum"
            label="工单流水号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="callPhone"
            show-overflow-tooltip
            label="来电号码"
          ></el-table-column>
          <el-table-column
            prop="seatPerson"
            show-overflow-tooltip
            label="受理人员"
          ></el-table-column>
          <el-table-column
            prop="adviceContent"
            show-overflow-tooltip
            label="咨询内容"
          ></el-table-column>
        </el-table>
        <Paginationmini
          :pageConfig="pageConfig2"
          @currentPage="currentChange2"
          @pageSize="pageSizeChange2"
        ></Paginationmini>
        <div class="sms_home"></div>
        <!-- </el-col> -->
      </div>
      <div class="clearfix">
        <!-- <el-col :sm="12"> -->
        <div class="sms_title">实体工单</div>
        <el-table
          class="form-table"
          :data="tableData2"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            fixed
            prop="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="states"
            label="处理结果"
            :formatter="statesFormat"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orderNum"
            show-overflow-tooltip
            label="工单流水号"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            show-overflow-tooltip
            label="客户姓名"
          ></el-table-column>
          <el-table-column
            prop="servestationName"
            show-overflow-tooltip
            label="机构"
          ></el-table-column>
          <el-table-column
            prop="servePersonName"
            show-overflow-tooltip
            label="服务人员"
          ></el-table-column>
          <el-table-column
            prop="serveproductName"
            show-overflow-tooltip
            label="服务名称"
          ></el-table-column>
        </el-table>
        <Paginationmini
          :pageConfig="pageConfig3"
          @currentPage="currentChange3"
          @pageSize="pageSizeChange3"
        ></Paginationmini>
        <div class="sms_home"></div>
        <!-- </el-col> -->
        <!-- <el-col :sm="12"> -->
        <div class="sms_title">回访记录</div>
        <el-table
          class="form-table"
          :data="tableData"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            fixed
            prop="date"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="visitTime"
            label="时间"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="visitName"
            show-overflow-tooltip
            label="回访类型"
          ></el-table-column>
          <el-table-column
            prop="note"
            show-overflow-tooltip
            label="通话记录"
          ></el-table-column>
          <el-table-column
            prop="note"
            show-overflow-tooltip
            label="回访流程"
          ></el-table-column>
        </el-table>
        <Paginationmini
          :pageConfig="pageConfig4"
          @currentPage="currentChange4"
          @pageSize="pageSizeChange4"
        ></Paginationmini>
        <div class="sms_home"></div>
        <!-- </el-col> -->
      </div>
    </div>
    <AddOrder
      v-if="addOrderTemp"
      @closeAddOrg="closeAddOrg"
      :id="queryid"
    ></AddOrder>
    <AddCustomer
      v-if="addCustomerTemp"
      @closeAddCuster="closeAddCuster"
    ></AddCustomer>
    <AddConsulte
      v-if="addConsulteTemp"
      @closeAddConsulte="closeAddConsulte"
      :id="queryid"
    ></AddConsulte>
    <AddService
      v-if="addServiceTemp"
      @closeAddService="closeAddService"
      :id="queryid"
    ></AddService>
  </div>
</template>
<script src="js/jquery-3.2.1.js"></script>
<script src="js/ghAgent.js"></script>
<script src="js/ghStandardAgentUi.js"></script>
<script>
import { metaDataMgrDao } from "@/api/dao.js"
import AddOrder from "./add/add_order1.vue"
import AddConsulte from "./add/add_consultation.vue"
import AddCustomer from "./add/add_customer.vue"
import AddService from "./add/query_customer.vue"
import Paginationmini from "./add/pagination-mini"
export default {
  name: "HomePage",
  props: ["phone"],
  data() {
    return {
      time: "",
      phones: "",
      userId: "",
      queryid: "",
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableDatas: [],
      loginName: "",
      belongAddressId: "",
      aghentPhone: this.phone,
      orderEntry: true,
      addOrderTemp: false,
      addConsulteTemp: false,
      addCustomerTemp: false,
      addServiceTemp: false,
      form: {
        id: "",
        name: "",
        phone: "",
        address: "",
        type: "",
        provinceName: "",
        city: "",
        zone: "",
        street: "",
        shequ: "",
        communityLeaders: "",
        leadersPhone: "",
      },
      pageConfig4: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig1: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig2: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig3: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      checkList: ["自动闲置", "自动摘机"],
    }
  },
  methods: {
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    addCustomer: function () {
      this.orderEntry = false
      this.addCustomerTemp = true
    },
    closeAddCuster: function () {
      this.orderEntry = true
      this.addCustomerTemp = false
      // parent.location.reload();
      //this.init();
    },
    addOrder: function (id) {
      this.queryid = id
      this.orderEntry = false
      this.addOrderTemp = true
    },
    addConsult: function (id) {
      this.queryid = id
      this.orderEntry = false
      this.addConsulteTemp = true
    },
    closeAddConsulte: function () {
      this.orderEntry = true
      this.addConsulteTemp = false
      // parent.location.reload();
    },
    closeAddOrg: function () {
      this.orderEntry = true
      this.addOrderTemp = false
      //  parent.location.reload();
    },
    addService: function (id) {
      if (id) {
        this.queryid = id
        this.orderEntry = false
        this.addServiceTemp = true
      } else {
        this.$message("暂无电话呼入")
        this.orderEntry = true
        this.addServiceTemp = false
      }
    },
    closeAddService: function () {
      this.orderEntry = true
      this.addServiceTemp = false
      //  parent.location.reload();
    },

    query(phone) {
      var _this = this
      if (phone != null && phone != "") {
        console.log("坐席来电弹屏号码" + phone)
        var formData = new FormData()
        formData.append("phone", phone)
        if (this.belongAddressId != null && this.belongAddressId != "") {
          formData.append("belongAddressId", this.belongAddressId)
        } else {
          formData.append("belongAddressId", "")
        }
        //const loading = this.$loading({
        // lock: true,
        // text: 'Loading',
        // spinner: 'el-icon-loading',
        // background: 'rgba(0, 0, 0, 0.7)',
        // target: document.querySelector('.div1')
        //});
        metaDataMgrDao.getCustomerByPhone(formData).then((resp) => {
          if (resp.code == "200") {
            if (resp.content != null) {
              this.getFuWuDuiXiang(resp.content.id)
            } else {
              _this.form.phone = phone
              console.log(resp)
              this.$message("客户不存在，请新增")
              //loading.close();
            }
          } else if (resp.code == "500") {
            this.$message("系统异常，请稍后重试")
          } else {
            this.$alert("认证失败，重新登录！", "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                this.$router.push({ path: "/login" })
              },
            })
          }
        })
      } else {
        // this.$message("手机号为空");
      }
    },
    getFuWuDuiXiang(id) {
      var _this = this
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.getfuwuduixiang(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let list = resp.content
            console.log(list.name)
            _this.form.name = list.name
            _this.form.phone = list.phone
            _this.form.address = list.address
            _this.form.id = list.id
            var type = ""
            switch (list.type) {
              case 7:
                type = "商业客户"
                break
              case 3:
                type = "残联客户"
                break
              case 6:
                type = "民政客户"
                break
            }
            _this.form.type = type
            _this.form.provinceName = list.provinceName
            _this.form.city = list.city
            _this.form.zone = list.zone
            _this.form.street = list.street
            _this.form.shequ = list.shequ
            _this.form.communityLeaders = list.communityLeaders
            _this.form.leadersPhone = list.leadersPhone
            // loading.close();
          } else {
            this.$message("暂无数据")
            console.log(resp)
          }
        } else if (resp.code == "500") {
          this.$message("系统异常，请稍后重试")
          this.tableData = this.tableData.concat(null)
          this.loading = false
        } else {
          this.$alert("认证失败，重新登录！", "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            callback: (action) => {
              this.$router.push({ path: "/login" })
            },
          })
          this.loading = false
        }
        this.loading = false
      })
    },
    //通话记录
    advice(tellphone) {
      console.log("通话记录来电弹屏号码" + tellphone)
      if (tellphone) {
        var formData = new FormData()
        formData.append("pageNo", this.pageConfig1.pageNo)
        formData.append("pageSize", this.pageConfig1.pageSize)
        formData.append("remoteNum", tellphone)
        if (this.belongAddressId != null && this.belongAddressId != "") {
          formData.append("belongAddressId", this.belongAddressId)
        } else {
          formData.append("belongAddressId", "")
        }
        metaDataMgrDao.findRecFileInfo(formData).then((resp) => {
          if (resp.code == "200") {
            if (resp.content != null) {
              console.log(resp)
              this.tableData1 = []
              let list = resp.content.list
              let currentPageNo = resp.content.pageNo
              let currentFirstIndex =
                (currentPageNo - 1) * this.pageConfig1.pageSize + 1
              for (let o of list) {
                o.index = currentFirstIndex
                o.key = currentFirstIndex
                currentFirstIndex++
              }
              this.pageConfig1.total = resp.content.count
              this.tableData1 = this.tableData1.concat(list)
            } else {
              console.log(resp)
              this.tableData1 = []
              var count = 0
              this.pageConfig1.total = count
            }
          } else if (resp.code == "500") {
            // this.$message("系统异常，请稍后重试");
            this.tableData1 = this.tableData1.concat(null)
          } else {
            this.$alert("认证失败，重新登录！", "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                this.$router.push({ path: "/login" })
              },
            })
          }
        })
      } else {
        this.tableData1 = this.tableData1.concat(null)
      }
    },
    currentChange1(currentPage) {
      this.pageConfig1.pageNo = currentPage
      this.advice()
    },
    pageSizeChange1(size) {
      this.pageConfig1.pageSize = size
    },
    //咨询工单
    record(tellphone) {
      console.log("咨询工单来电弹屏号码" + tellphone)
      if (tellphone) {
        var formData = new FormData()
        formData.append("pageNo", this.pageConfig2.pageNo)
        formData.append("pageSize", this.pageConfig2.pageSize)
        formData.append("callPhone", tellphone)
        if (this.belongAddressId != null && this.belongAddressId != "") {
          formData.append("belongAddressId", this.belongAddressId)
        } else {
          formData.append("belongAddressId", "")
        }
        metaDataMgrDao.findAdvicepgd(formData).then((resp) => {
          if (resp.code == "200") {
            if (resp.content != null) {
              console.log(resp)
              this.tableDatas = []
              let list = resp.content.list
              let currentPageNo = resp.content.pageNo
              let currentFirstIndex =
                (currentPageNo - 1) * this.pageConfig2.pageSize + 1
              for (let o of list) {
                o.index = currentFirstIndex
                o.key = currentFirstIndex
                currentFirstIndex++
              }
              this.pageConfig2.total = resp.content.count
              this.tableDatas = this.tableDatas.concat(list)
            } else {
              console.log(resp)
              this.tableDatas = []
              var count = 0
              this.pageConfig2.total = count
            }
          } else if (resp.code == "500") {
            //  this.$message("系统异常，请稍后重试");
            this.tableDatas = this.tableDatas.concat(null)
          } else {
            this.$alert("认证失败，重新登录！", "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                this.$router.push({ path: "/login" })
              },
            })
          }
        })
      } else {
        this.tableDatas = this.tableDatas.concat(null)
      }
    },
    currentChange2(currentPage) {
      this.pageConfig2.pageNo = currentPage
      this.record()
    },
    pageSizeChange2(size) {
      this.pageConfig2.pageSize = size
    },
    //实体工单
    servicePgd(tellphone) {
      console.log("实体工单来电弹屏号码" + tellphone)
      if (tellphone) {
        var formData = new FormData()
        formData.append("pageNo", this.pageConfig3.pageNo)
        formData.append("pageSize", this.pageConfig3.pageSize)
        formData.append("customerphone", tellphone)
        if (this.belongAddressId != null && this.belongAddressId != "") {
          formData.append("belongAddressId", this.belongAddressId)
        } else {
          formData.append("belongAddressId", "")
        }
        metaDataMgrDao.getServicePGD(formData).then((resp) => {
          if (resp.code == "200") {
            if (resp.content != null) {
              console.log(resp)
              this.tableData2 = []
              let list = resp.content.list
              let currentPageNo = resp.content.pageNo
              let currentFirstIndex =
                (currentPageNo - 1) * this.pageConfig3.pageSize + 1
              for (let o of list) {
                o.index = currentFirstIndex
                o.key = currentFirstIndex
                currentFirstIndex++
              }
              this.pageConfig3.total = resp.content.count
              this.tableData2 = this.tableData2.concat(list)
              //loading.close();
            } else {
              console.log(resp)
              this.tableData2 = []
              var count = 0
              this.pageConfig3.total = count
              // loading.close();
            }
          } else if (resp.code == "500") {
            //   this.$message("系统异常，请稍后重试");
            this.tableData2 = this.tableData2.concat(null)
          } else {
            this.$alert("认证失败，重新登录！", "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                this.$router.push({ path: "/login" })
              },
            })
          }
        })
      } else {
        this.tableData2 = this.tableData2.concat(null)
      }
    },
    currentChange3(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.servicePgd()
    },
    pageSizeChange3(size) {
      this.pageConfig3.pageSize = size
    },
    //回访记录
    visitServicePgd(tellphone) {
      console.log("回访记录来电弹屏号码" + tellphone)
      if (tellphone) {
        var formData = new FormData()
        formData.append("pageNo", this.pageConfig4.pageNo)
        formData.append("pageSize", this.pageConfig4.pageSize)
        formData.append("customerPhone", tellphone)
        if (this.belongAddressId != null && this.belongAddressId != "") {
          formData.append("belongAddressId", this.belongAddressId)
        } else {
          formData.append("belongAddressId", "")
        }
        metaDataMgrDao.findReturnPgd(formData).then((resp) => {
          if (resp.code == "200") {
            if (resp.content != null) {
              console.log(resp)
              this.tableData = []
              let list = resp.content.list
              let currentPageNo = resp.content.pageNo
              let currentFirstIndex =
                (currentPageNo - 1) * this.pageConfig4.pageSize + 1
              for (let o of list) {
                o.index = currentFirstIndex
                o.key = currentFirstIndex
                currentFirstIndex++
              }
              this.pageConfig4.total = resp.content.count
              this.tableData = this.tableData.concat(list)
            } else {
              console.log(resp)
              this.tableData = []
              var count = 0
              this.pageConfig4.total = count
            }
          } else if (resp.code == "500") {
            //      this.$message("系统异常，请稍后重试");
            this.tableData = this.tableData.concat(null)
          } else {
            this.$alert("认证失败，重新登录！", "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: (action) => {
                this.$router.push({ path: "/login" })
              },
            })
          }
          this.tableLoading = false
          console.log(resp)
        })
      } else {
        this.tableData = this.tableData.concat(null)
      }
    },
    currentChange4(currentPage) {
      this.pageConfig4.pageNo = currentPage
      this.visitServicePgd()
    },
    pageSizeChange4(size) {
      this.pageConfig4.pageSize = size
    },
  },
  //beforeRouteEnter : function(to, from, next){
  // console.log("局部查询刷新")
  // next(vm => {
  // console.log("执行"+vm)
  //   var phone=sessionStorage.setItem("aghentPhone",val);
  //   vm.query(phone);
  //   vm.advice(phone);
  //   vm.record(phone);
  //   vm.servicePgd(phone)
  //     vm.visitServicePgd(phone)
  //   });
  // },

  mounted: function () {
    console.log("获取路由传递参数：" + this.$route.query.key)
    if (this.$route.query.key != null && this.$route.query.key != "") {
      this.aghentPhone = this.$route.query.key
    }

    if (sessionStorage.getItem("username")) {
      var username = sessionStorage.getItem("username")
      this.loginName = username
      console.log(this.usernames)
    }
    if (sessionStorage.getItem("user")) {
      var a = sessionStorage.getItem("user")
      this.belongAddressId = a
      console.log(this.belongAddressId)
    }
    if (sessionStorage.getItem("userId")) {
      var userIds = sessionStorage.getItem("userId")
      this.userId = userIds
      console.log(this.userId)
    }
    if (sessionStorage.getItem("aghentPhone")) {
      var aghentPhones = sessionStorage.getItem("aghentPhone")
      this.aghentPhone = aghentPhones
      console.log("缓存号码" + this.aghentPhone)
    }
    var phone = this.aghentPhone
    this.query(phone)
    this.advice(phone)
    this.record(phone)
    this.servicePgd(phone)
    this.visitServicePgd(phone)
    console.log("本次查询的号码为", phone)
  },
  watch: {
    aghentPhone(val, oldVal) {
      //普通的watch监听
      console.log("aghentPhone: " + val, oldVal)
      this.query(val)
      this.advice(val)
      this.record(val)
      this.servicePgd(val)
      this.visitServicePgd(val)
    },
  },
  components: {
    AddOrder,
    AddConsulte,
    AddCustomer,
    Paginationmini,
    AddService,
  },
}
</script>
<style lang="less">
@import "./add/service.less";
</style>
<style scoped>
@import "./add/ghStandardAgentUi.css";
</style>
